import React from 'react'
import { SwitchContainer, Input, Label, Text, Slider } from './styles'

const ToggleSwitch = ({ checked, label, name, togglePap, ...props }) => {
  const inputProps = props.input
  return (
    <div>
      <SwitchContainer>
        <Label>
          <Input
            {...inputProps}
            {...props}
            onChange={() => togglePap(!checked)}
            checked={checked}
            type="checkbox"
            name={name}
          />
          <Slider className="slider round" />
        </Label>
      </SwitchContainer>
      <Text>{label}</Text>
    </div>
  )
}

export default ToggleSwitch



// WEBPACK FOOTER //
// ./src/app/elements/ToggleSwitch/index.js